<template>
  <div class="containerTable">
    <div class="titleh1"><code />平台充值</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="充值金额" prop="balance">
        <el-input
          v-model="form.balance"
          placeholder="请输入充值金额"
        />
      </el-form-item>
      <el-form-item label="选择商户" prop="name">
        <el-input
          ref="focus"
          v-model="form.name"
          placeholder="请选择商户"
          @focus="vardel = true"
        />
      </el-form-item>
      <el-form-item label="商户ID">
        <el-input
          :value="form.accountId"
          placeholder="商户ID"
          disabled
        />
      </el-form-item>
      <el-form-item v-if="showChargeConfig" label="流水号" prop="orderNo">
        <el-input
          v-model="form.orderNo"
          @change="
            (value) => {
              form.orderNo = value.replace(/\W/g, '');
            }
          "
        />
      </el-form-item>
      <el-form-item v-if="showChargeConfig" label="支付凭证" required>
        <ImgUpload
          :upload-config="{
            lebal: '支付凭证',
            prefix: 'payReceipt',
            form: form,
            suffix: 'Img',
          }"
        />
      </el-form-item>
      <!-- 请选择手机号 -->
      <el-collapse
        v-if="showChargeConfigPhone && configKey === 'charge' && showChargeConfig"
        v-model="activeNames"
        style="margin-bottom: 20px"
      >
        <el-collapse-item title="请选择手机号" name="1">
          <el-radio-group
            v-for="(phone1, index) in phoneArray"
            :key="index"
            v-model="queryObj.phone"
          >
            <el-radio :label="phone1" style="margin-right: 10px">{{
              phone1
            }}</el-radio>
          </el-radio-group>
        </el-collapse-item>
      </el-collapse>
      <el-row v-if="showChargeConfig" :gutter="20">
        <el-col :span="20">
          <el-form-item label="获取验证码" prop="smsCode">
            <el-input
              v-model="form.smsCode"
              maxlength="20"
              placeholder="请输入验证码"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <verificationCode
            ref="ishowRef"
            :api-fun="sendCentralCode"
            :query-obj="queryObj"
          />
        </el-col>
      </el-row>
      <el-form-item v-if="showType" label="充值类型" prop="paytype">
        <el-select
          v-model="form.paytype"
          placeholder="请选择充值类型"
          :readonly="true"
        >
          <el-option
            v-for="item in stateArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="paidRemark">
        <el-input
          v-model="form.paidRemark"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="getLimit('merchantPayment_add_button')"
          type="primary"
          @click="submitForm('form')"
        >
          保存并新增
        </el-button>
      </el-form-item>
    </el-form>
    <vxe-modal
      v-model="vardel"
      width="1000"
      height="80%"
      title="选择商户"
      resize
    >
      <!-- v-if 解决表格无法铺满弹框问题 -->
      <Selectuser v-if="vardel" ref="ShipperlRef" @event1="receive" />
    </vxe-modal>
  </div>
</template>
<script>
import ImgUpload from "@/components/ImgUpload";
import { rechargeConfig } from "@/api/invoice";
import { merchantRecharge } from "@/api/merchantCenter";
import { getConfigPhone } from "@/api/transport";
import Selectuser from "./components/Selectuser.vue";
import { getRole } from "@/utils/getRole";
import { isCellphone, isFixed2New } from "@/utils/validate4Form";
import { sendCentralCode } from "@/api/InternetBanking";
import verificationCode from "@/components/verificationCode";
export default {
  components: {
    Selectuser,
    ImgUpload,
    verificationCode,
  },
  data() {
    return {
      configKey: "",
      activeNames: ["1"],
      phoneArray: [],
      stateArr: [
        { label: "余额", value: 0 },
        { label: "保证金", value: 1 },
      ],
      vardel: false,
      showType: false,
      showCode: true,
      showChargeConfig: false,
      showChargeConfigPhone: false,
      sendCentralCode,
      queryObj: {},
      form: {
        code: "",
        balance: "",
        paidRemark: "",
        name: "",
        accountId: "",
        platPhone: "",
        phone: "",
        paytype: "",
        type: "2",
      },
      rules: {
        balance: [{
          required: true,
          validator: isFixed2New,
          trigger: 'blur'
        }],
        name: [{ required: true, message: "请选择商户", trigger: "blur" }],
        phone: [{ required: true, validator: isCellphone, trigger: "blur" }],
        paidRemark: [
          { required: true, message: "请输入备注", trigger: "blur" },
          { max: 100, message: "长度不能超过100个字符" },
        ],
        orderNo: [
          { required: true, message: "请输入流水号", trigger: "blur" },
          { max: 64, message: "长度不能超过64个字符" },
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { max: 20, message: "长度不能超过20个字符" },
        ],
      },
      count: 0,
    };
  },
  created() {
    // 判断验证码是否显示
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const partyType = this.$store.getters.party.partyType;
    let isShipment = partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    this.queryObj = {
      partyGroupCode: this.$store.state.user.party.branchCode,
      type: 2,
      phone: "",
      source: isShipment ? "shipment" : "",
    };
    rechargeConfig()
      .then((r) => {
        let res = r.data;
        this.showChargeConfig = res[0].configValue === "0";
        this.configKey = res[0].configKey;
        this.showChargeConfigPhone = res[1].configValue === "arpa_2";
      })
      .then(() => {
        //  获取配置的手机号 -设置默认手机号
        let party = this.$store.getters.party;
        if (this.showChargeConfigPhone) {
          this.configPhone = party.phone;
          getConfigPhone().then((res) => {
            if (res.data.length > 0) {
              this.phoneArray = res.data || [];
            }
            if (this.phoneArray.includes(this.configPhone)) {
              this.queryObj.phone = this.configPhone;
            } else {
              this.queryObj.phone = "";
            }
          });
        }
      });
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          this.form.platPhone = this.queryObj.phone;
          merchantRecharge(this.form)
            .then((response) => {
              this.$message({ message: response.msg, type: "success" });
              this.form = {
                code: "",
                balance: "",
                name: "",
                accountId: "",
                paidRemark: "",
                platPhone: "",
                phone: "",
              };
              this.showCode = true;
              clearInterval(this.timer);
              this.timer = null;
            })
            .finally(() => {
              rLoading.close();
            });
        } else {
          return false;
        }
      });
    },
    receive(data) {
      this.$refs.focus.focus();
      this.form.name = data.name;
      this.form.accountId = data.accountId;
      this.form.code = data.code;
      this.form.phone = data.phone;
      if (getRole()) {
        if (data.partyType == "DRIVER_LEADER" || data.partyType == "DRIVER") {
          this.showType = true;
        } else {
          this.showType = false;
        }
      }
      this.vardel = false;
    },

    //获取验证码
    async getCode() {
      let form = {
        partyGroupCode: this.$store.state.user.party.branchCode,
        type: 2,
      };
      const rLoading = this.openLoading();
      let response = await sendCentralCode(form);
      rLoading.close();
      this.$message.success(response.msg);
      this.updating = false;
      if (response.status == 0) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showCode = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.showCode = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.el-autocomplete {
  width: 81%;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
</style>
